export default __webpack_public_path__ + "static/media/logo-positivo-tagline.184b69aa.png";